import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/core/material/material.module';

import { GoogleMapsModule } from '@angular/google-maps';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  // The version line is chrome, not content: it is not what a Cmd+A on the screen is reaching for.
  styles: `
    #footerComponent {
      user-select: none;
    }
  `,
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, MaterialModule, GoogleMapsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public currentYear = new Date().getFullYear();
  currentApplicationVersion = environment.appVersion;

  printVersion(): string {
    return `v${this.currentApplicationVersion}`;
  }
}
